<template>
  <el-dialog
    :visible.sync="dialogVisible"
    width="35%"
    top="60px"
    :fullscreen="dialogFull"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    :before-close="handleClose"
    append-to-body
    :modal-append-to-body="false"
  >
    <template slot="title">
      <div class="avue-crud__dialog__header">
        <span class="el-dialog__title"> 添加车辆 </span>
        <i
          class="el-icon-full-screen"
          style="margin-right: 20px; position: relative; top: -1px"
          @click="dialogFull = !dialogFull"
        ></i>
      </div>
    </template>
    <el-dialog
      title="车位组中车辆导入"
      append-to-body
      :visible.sync="showUploadDialog"
      :close-on-click-modal="false"
      width="555px"
      accept="vnd.ms-excel"
    >
      <avue-form
        v-if="showUploadDialog"
        :option="ImportExcelOption"
        ref="excelform"
        v-model="upload"
        :upload-after="uploadAfter"
        :before-upload="beforeUpload"
      >
        <template slot-scope="scope" slot="downloadAction">
          模板下载:
          <el-button type="primary" size="small" icon="el-icon-plus" @click="exportDemoExcel"
            >下载模板
          </el-button>
          <!-- <el-button @click="tip">自定义按钮</el-button> -->
        </template>
      </avue-form>
    </el-dialog>
    <div style="max-height: calc(100vh - 300px); overflow: scroll">
      <div>
        车位组名称:
        <el-select v-model="carParkGroupName" disabled> </el-select>
      </div>
      <div style="margin: 20px 0; display: flex; justify-content: flex-start">
        <!-- <el-upload
                                accept=".xls, .xlsx"
                                limit="1"
                                style="display: inline-block; vertical-align: top;margin-right:10px;"
                                ref="upload"
                                action=""
                                :auto-upload="false"
                                :http-request="uploadImg"
                                :on-success="uploadImgSuccess"
                                :on-change="loadJsonFromFile"
                                :on-remove="handleRemove"
                        > -->
        <el-button type="primary" size="small" icon="el-icon-upload" plain @click="opneUpdateDialog"
          >批量导入</el-button
        >
        <!-- </el-upload> -->

        <!-- <el-button
                                type="primary"
                                size="small"
                                icon="el-icon-download"
                                plain
                                @click="handleExport"
                                >
                        下载模板
                        </el-button> -->
      </div>
      <avue-form
        ref="form"
        v-model="form"
        :option="option"
        @reset-change="emptytChange"
        @submit="submit"
      >
      </avue-form>
    </div>
    <template slot="footer">
      <el-button @click="formSubmit1" size="small" type="primary"
        ><span class="el-icon-check" :disabled="disabled"></span> 保存</el-button
      >
      <el-button @click="handleClose" size="small" style="margin-right: 15px"
        ><span class="el-icon-close" :disabled="disabled"></span> 取消</el-button
      >
    </template>
  </el-dialog>
</template>
<script>
import { addGroupCars } from '@/api/v4ward/carv2/cargroup';
import { getToken } from '@/util/auth';
export default {
  data() {
    var validateCarInfos = (rule, value, callback) => {
      let temArr = [];
      for (let key in value) {
        let ele = value[key];

        if (this.vdui.isEmpty(ele.plateNumber)) {
          callback(new Error('请输入车牌！'));
          return;
        } else if (!this.$validation.carPlate.test(ele.plateNumber)) {
          callback(new Error('车牌格式不正确！'));
          return;
        } else if (temArr.indexOf(ele.plateNumber) > -1) {
          callback(new Error('请不要输入重复车牌！'));
          return;
        }
        temArr.push(ele.plateNumber);
      }
      callback();
    };
    return {
      showUploadDialog: false,
      carParkGroupName: '',
      parkGroupId: '',
      spaceId: '',
      disabled: false,
      form: {
        list: [],
      },
      dialogVisible: false,
      dialogFull: false,

      ImportExcelOption: {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '数据上传',
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            dragFile: true,
            showFileList: false,
            loadText: '数据上传中，请稍等',
            span: 24,
            propsHttp: {
              res: 'data',
            },
            data: {
              spaceId: this.spaceId,
              groupId: this.parkGroupId,
            },
            tip: '请上传 .xls,.xlsx 标准格式文件',
            action: '/api/v4ward/car/in/park/group/importCarInGroup/v2',
          },

          {
            label: '模板下载',
            prop: 'downloadAction',
            formslot: true,
          },
        ],
      },
      option: {
        labelWidth: 0,
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            type: 'dynamic',
            span: 24,
            prop: 'list',
            display: true,
            rules: [
              {
                required: true,
                message: '请添加车辆信息',
                trigger: 'change',
              },
              { validator: validateCarInfos, trigger: 'blur' },
            ],
            children: {
              align: 'center',
              headerAlign: 'center',
              index: false,
              addBtn: true,
              delBtn: true,
              column: [
                {
                  type: 'input',
                  label: '车牌号',
                  span: 24,
                  display: true,
                  prop: 'plateNumber',
                  required: true,
                  rules: [
                    {
                      required: true,
                      message: '请输入车牌',
                      trigger: 'blur',
                    },
                    {
                      required: true,
                      pattern: this.$validation.carPlate,
                      message: '车牌格式不对',
                      trigger: 'change',
                    },
                  ],
                },
              ],
            },
          },
        ],
      },
    };
  },
  methods: {
    opneUpdateDialog() {
      console.log(123);
      this.showUploadDialog = true;
    },
    uploadAfter(res, done) {
      done();
      if (this.vdui.isEmpty(String(res))) {
        this.$message.success('导入成功！');
        this.showUploadDialog = false;
      }
    },
    exportDemoExcel() {
      this.$confirm('是否导出模板数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        //导出设备设施模版
        window.open(
          `/api/v4ward/car/in/park/group/exportTemplateCarInGroup/v2?${
            this.website.tokenHeader
          }=${getToken()}&spaceId=` + this.spaceId
        );
      });
    },
    openDialog(row) {
      console.log(row);
      this.form = {
        list: [],
      };
      this.carParkGroupName = row.carParkGroupName;
      this.parkGroupId = row.id;
      this.spaceId = row.parkingLotId;
      this.ImportExcelOption.column[0].data.spaceId = this.spaceId;
      this.ImportExcelOption.column[0].data.groupId = this.parkGroupId;
      this.dialogVisible = true;
    },
    submit(form, down) {
      console.log(form);
      this.disabled = true;
      let temArr = [];
      this.form.list.forEach((ele) => {
        temArr.push({
          spaceId: this.spaceId,
          parkGroupId: this.parkGroupId,
          plateNumber: ele.plateNumber,
        });
      });
      addGroupCars(temArr)
        .then((res) => {
          if (res.success) {
            this.$message.success('操作成功!');
          }
          down();
          this.dialogVisible = false;
          this.disabled = false;
        })
        .catch((err) => {
          down();
          this.disabled = false;
        });
    },
    formSubmit1() {
      this.$refs.form.submit();
    },
    // 弹窗关闭前
    handleClose(done) {
      let self = this;
      this.$confirm('确认关闭?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.dialogVisible = false;
        })
        .catch(() => {});
    },
  },
};
</script>
